<template>
  <picture v-if="src" data-lazy="true" class="sp-responsive-image">
    <source v-if="srcSmall" :srcset="srcSmall" :media="mediaSmall" />
    <source v-if="srcMedium" :srcset="srcMedium" :media="mediaMedium" />
    <source v-if="srcLarge" :srcset="srcLarge" :media="mediaLarge" />
    <img :src="src" :alt="alt" />
  </picture>
</template>

<script setup>
import { computed } from "vue";
import { useBreakpoints } from "../../composables/breakpoints";

defineProps({
  src: {
    type: String,
    required: true,
  },
  srcSmall: {
    type: String,
    default: undefined,
  },
  srcMedium: {
    type: String,
    default: undefined,
  },
  srcLarge: {
    type: String,
    default: undefined,
  },
  alt: {
    type: String,
    default: undefined,
  },
});

const { smBreakpoint, lgBreakpoint } = useBreakpoints();

const mediaSmall = computed(() => `(max-width: ${smBreakpoint.value})`);
const mediaMedium = computed(() => `(max-width: ${lgBreakpoint.value})`);
const mediaLarge = computed(() => `(min-width: ${lgBreakpoint.value})`);
</script>

<style scoped lang="scss">
.sp-responsive-image {
  --border-radius: var(--sp-responsive-image-border-radius, var(--sp-comp-responsive-image-border-radius, 0));

  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border-radius: var(--border-radius);
    object-fit: cover;
  }
}
</style>
